let openResolve, openReject;

export default {
  namespaced: true,
  state: {
    entryModel: undefined
  },
  mutations: {
    setEntryModel: (state, entry) => {
      state.entryModel = entry;
    }
  },
  actions: {
    // Open sidebar and return a promise to be fulfilled when the user presses Update or Cancel.
    entrySidebarOpenAsync: ({commit}, entry) => {
      commit('setEntryModel', {...entry});
      return new Promise((resolve, reject) => {
        openResolve = resolve;
        openReject = reject;
      })
    },
    entrySidebarOpen: ({commit}, entry) => {
      commit('setEntryModel', {...entry});
    },

    // Update 
    entrySidebarUpdate: ({commit,state}, model) => {
      if (openResolve instanceof Function) {
        openResolve({ action: 'update', model: model});
      }
      commit('setEntryModel', undefined);
    },

    // Notification 
    entrySidebarNotification: ({commit,state}) => {
      if (openResolve instanceof Function) {
        
        openResolve({ action: 'notification', model: state.entryModel});
      }
      commit('setEntryModel', undefined);
    },

    // Delete
    entrySidebarDelete: ({commit, state}) => {
      if (openResolve instanceof Function) {
        openResolve({ action: 'delete', model: state.entryModel});
      }
      commit('setEntryModel', undefined);
    },

    // Cancel
    entrySidebarCancel: ({commit, state}) => {
      if (openResolve instanceof Function) {
        openResolve({ action: 'cancel', model: state.entryModel});
      }
      commit('setEntryModel', undefined);
    },
    // Update 
    entrySidebarViewUpdate: ({commit,state}, entry) => {
      if(entry) {        
        commit('setEntryModel', {...entry});
      }
    },
    // Update 
    entrySidebarSplit: ({commit,state}) => {
      if (openResolve instanceof Function) {
        openResolve({ action: 'split', model: state.entryModel});
      }
      commit('setEntryModel', undefined);
    },
  },
  getters: {
    entrySidebarModel: (state) => state.entryModel
  }
}